import type { ReactNode } from "react";

import type { DataSourceSelectorProps } from "metabase/embedding-sdk/types/components/data-picker";
import type { State } from "metabase/redux/store";
import type { EmbeddingEntityType } from "metabase/redux/store/embedding-data-picker";
import type { TableId } from "metabase-types/api";

import { definePluginSlot } from "../slot";

export interface SimpleDataPickerProps {
  filterByDatabaseId: number | null;
  selectedEntity?: TableId;
  isInitiallyOpen: boolean;
  triggerElement: ReactNode;
  setSourceTableFn: (tableId: TableId) => void;
  entityTypes: EmbeddingEntityType[];
}

const getDefaultPluginEmbedding = () => ({
  isEnabled: () => false,
  isInteractiveEmbeddingEnabled: (_state: State) => false,
  SimpleDataPicker: (_props: SimpleDataPickerProps): ReactNode => null,
  DataSourceSelector: (_props: DataSourceSelectorProps): ReactNode => null,
});

export const PLUGIN_EMBEDDING = definePluginSlot(getDefaultPluginEmbedding);
